__turbopack_context__.v({
  "generic-tip": "GenericTip-module-scss-module__0aP2Wq__generic-tip",
  "still-alternative": "GenericTip-module-scss-module__0aP2Wq__still-alternative",
});
